/**
 * Swagger Lucor
 * Swagger Lucor
 *
 * OpenAPI spec version: 1.2.18
 * Contact: roger.cazangi@hotmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Login } from '../model/login';
import { TokenAcesso } from '../model/tokenAcesso';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';

import { environment } from 'environments/environment';


@Injectable()
export class LoginService {

    protected basePath = environment.apiBasePath;
    public version = environment.version;
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    public systemVersion() {
        return this.version;
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Efetuar Login
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    // public v1LoginPost(body?: Login, observe?: 'body', reportProgress?: boolean): Observable<TokenAcesso>;
    // public v1LoginPost(body?: Login, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TokenAcesso>>;
    // public v1LoginPost(body?: Login, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TokenAcesso>>;
    // public v1LoginPost(body?: Login, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


    //     let headers = this.defaultHeaders;

    //     // authentication (Bearer) required
    //     if (this.configuration.accessToken) {
    //         const accessToken = typeof this.configuration.accessToken === 'function'
    //             ? this.configuration.accessToken()
    //             : this.configuration.accessToken;
    //         headers = headers.set('Authorization', 'Bearer ' + accessToken);
    //     }
    //     // to determine the Accept header
    //     let httpHeaderAccepts: string[] = [
    //         'text/plain',
    //         'application/json',
    //         'text/json'
    //     ];
    //     const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    //     if (httpHeaderAcceptSelected != undefined) {
    //         headers = headers.set('Accept', httpHeaderAcceptSelected);
    //     }

    //     // to determine the Content-Type header
    //     const consumes: string[] = [
    //         'application/json',
    //         'text/json',
    //         'application/_*+json'
    //     ];
    //     const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    //     if (httpContentTypeSelected != undefined) {
    //         headers = headers.set('Content-Type', httpContentTypeSelected);
    //     }

    //     return this.httpClient.request<TokenAcesso>('post',`${this.basePath}/v1/Login`,
    //         {
    //             body: body,
    //             withCredentials: this.configuration.withCredentials,
    //             headers: headers,
    //             observe: observe,
    //             reportProgress: reportProgress
    //         }
    //     );
    // }

    public v1LoginPost(usuario?: Login, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public v1LoginPost(usuario?: Login, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public v1LoginPost(usuario?: Login, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public v1LoginPost(usuario?: Login, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Login>(`${this.basePath}/v1/Login`,
            usuario,
            {
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

}
